import { api } from './client';

interface LoginRequest {
  username: string;
  password: string;
}

interface LoginResponse {
  access_token: string;
  token_type: string;
}

interface TokenValidationResponse {
  valid: boolean;
  username: string;
}

export const authApi = {
  /**
   * Login with username and password
   */
  login: (credentials: LoginRequest): Promise<LoginResponse> => {
    return api.post<LoginResponse>('/auth/login', credentials, { skipAuth: true });
  },

  /**
   * Validate current token
   */
  validateToken: (): Promise<TokenValidationResponse> => {
    return api.post<TokenValidationResponse>('/auth/validate');
  },
};
